import { defineStore } from 'pinia';
import StorageService from 'ewi-ui-helpers/storageService.js';

export const calculatorStore = defineStore('calculatorStore', {
  state: () => ({
    formData: null,
    error: null,
  }),
  getters: {},
  actions: {
    saveFormData(calculatorType, customerType, formData) {
      StorageService.save(
        calculatorType + customerType + 'CalculatorFormData',
        formData,
      );
      StorageService.save(
        'LastUsedCalculator',
        JSON.stringify({
          calculatorType,
          customerType,
        }),
      );
    },
    getFormData(calculatorType, customerType) {
      return StorageService.read(
        calculatorType + customerType + 'CalculatorFormData',
      );
    },
    getLastUsedCalculator() {
      let lastUsedCalculator = StorageService.read('LastUsedCalculator');
      if (lastUsedCalculator !== null) {
        return {
          calculatorType: lastUsedCalculator.calculatorType,
          customerType: lastUsedCalculator.customerType,
        };
      }
      return null;
    },
  },
});
